import { AnswerItem } from 'models/AnswerItem';
import React from 'react';
import 'assets/scss/short-answers.scss';

type shortAnswersContentProps = {
	answerItems: AnswerItem[];
};

export const ShortAnswersContent = ({ answerItems }: shortAnswersContentProps) => {
	return (
		<div className="short-answers-container">
			{answerItems.map((answer, index) => {
				return (
					<div key={index} className="short-answers-item">
						<img
							src={answer.icon}
							alt={answer.title}
							style={{
								marginRight: 16,
								width: 32,
								height: 32,
							}}
						/>

						<div className="short-answers-item-content">
							<h3
								className="body-small negro-general"
								style={{
									marginBottom: 4,
									fontWeight: 'bold',
								}}
							>
								{answer.title}
							</h3>
							<div className="body-small gris-6">{answer.content}</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};
